import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const PolitikaZasebnosti = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-atren-gray">Politika zasebnosti</h1>
        
        <div className="prose prose-lg max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">1. Splošno</h2>
            <p>
              ATREN INVEST d.o.o. (v nadaljevanju: »podjetje«) spoštuje zasebnost uporabnikov 
              in se zavezuje k zaščiti osebnih podatkov v skladu z Uredbo (EU) 2016/679 (GDPR) 
              in slovensko zakonodajo.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">2. Upravljavec osebnih podatkov</h2>
            <p>
              Upravljavec osebnih podatkov je ATREN INVEST d.o.o.<br/>
              Naslov: Partizanska cesta 71d<br/>
              E-pošta: info@atren.eu<br/>
              Telefon: 070846087
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">3. Vrste osebnih podatkov</h2>
            <p>Zbiramo in obdelujemo naslednje osebne podatke:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Ime in priimek</li>
              <li>E-poštni naslov</li>
              <li>Telefonska številka</li>
              <li>Sporočilo (preko kontaktne forme)</li>
              <li>IP naslov in tehnični podatki o brskalniku</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">4. Namen obdelave</h2>
            <p>Osebne podatke obdelujemo za naslednje namene:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Odgovarjanje na povpraševanja</li>
              <li>Zagotavljanje storitev</li>
              <li>Izboljšanje spletne strani</li>
              <li>Izpolnjevanje zakonskih obveznosti</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">5. Pravna podlaga</h2>
            <p>
              Obdelava osebnih podatkov temelji na vaši privoliti (člen 6(1)(a) GDPR) 
              ali na upravičenih interesih podjetja (člen 6(1)(f) GDPR).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">6. Piškotki</h2>
            <p>
              Naša spletna stran uporablja piškotke za izboljšanje uporabniške izkušnje. 
              Več informacij o piškotkih najdete v našem obvestilu o piškotkih.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">7. Vaše pravice</h2>
            <p>V skladu z GDPR imate naslednje pravice:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Pravica do dostopa do osebnih podatkov</li>
              <li>Pravica do popravka</li>
              <li>Pravica do izbriga</li>
              <li>Pravica do prenosljivosti podatkov</li>
              <li>Pravica do ugovora</li>
              <li>Pravica do omejitve obdelave</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">8. Kontakt</h2>
            <p>
              Za vprašanja glede obdelave osebnih podatkov nas lahko kontaktirate na 
              e-poštni naslov: info@atren-invest.si
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">9. Spremembe</h2>
            <p>
              Pridržujemo si pravico do sprememb te politike zasebnosti. 
              Spremembe bodo objavljene na tej strani.
            </p>
            <p className="text-sm text-gray-500 mt-4">
              Zadnja posodobitev: {new Date().toLocaleDateString('sl-SI')}
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PolitikaZasebnosti;